<!--
 * @Author: lizhenzhen
 * @Date: 2020-11-17 09:45:37
 * @LastEditors: lizhenzhen
 * @LastEditTime: 2020-12-07 11:40:03
 * @FilePath: \jmax_tuqiang_em\src\components\batch-input-device\index.vue
 * @FileName 批量输入设备
-->
<template>
  <div
    :class="`batch-input-device ${isHover ? (!isFocus ? 'batch-input-device-hover' : '') : ''}`"
    :style="`width: ${width}`"
  >
    <ux-input
      v-if="!isArea"
      v-model="imei"
      :style="`width: ${width}`"
      :placeholder="placeholder"
      clearable
      @focus="focus"
      @clear="clear"
    ></ux-input>
    <div class="area-box" v-click-outside="close" v-else>
      <ux-input
        :style="`width: ${width}`"
        type="textarea"
        resize="none"
        :placeholder="placeholder"
        v-model="devices"
        v-number-only
        :rows="10"
        autofocus
        @change="onChange"
        @focus="isFocus = true"
        @blur="isFocus = false"
      ></ux-input>
      <div
        :class="`area-bottom ${isFocus ? 'area-bottom-focus' : ''}`"
        v-if="isArea"
        :style="`width: ${width}`"
        @mouseover="isHover = true"
        @mouseleave="isHover = false"
      >
        <div>
          <span>{{ staticText }}：</span
          ><span
            >{{ countNum
            }}{{
              `${limit != -1 ? '/' + limit : ''} ${
                limit != -1 && countNum > limit ? $t('HT.imeiInput.limit') : ''
              }`
            }}</span
          >
        </div>
        <div class="block-btn" v-if="!hideBtn">
          <ux-button size="small" style="marginright: 8px" @click="onCancle">{{
            cancleText
          }}</ux-button>
          <ux-button v-if="limit != -1 && countNum > limit" size="small" type="primary" disabled>{{
            confirmText
          }}</ux-button>
          <ux-button v-else size="small" type="primary" @click="onSubmit">{{
            confirmText
          }}</ux-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '@/i18n/index.js';

export default {
  name: 'imeiInput',
  model: {
    prop: 'value', // 要存在于props
    event: 'change' // 当组件的值发生改变时要emit的事件名
  },
  props: {
    placeholder: {
      type: String,
      default: () => i18n.t('HT.imeiInput.imei.placeholder')
    },
    confirmText: {
      type: String,
      default: () => i18n.t('HT.imeiInput.add')
    },
    cancleText: {
      type: String,
      default: () => i18n.t('HT.imeiInput.cancle')
    },
    staticText: {
      type: String,
      default: () => i18n.t('HT.imeiInput.static')
    },
    width: {
      type: String,
      default: '100%'
    },
    hideBtn: {
      type: Boolean,
      default: true
    },
    limit: {
      type: Number,
      default: -1
    },
    value: {
      type: String,
      default: ''
    }
  },
  directives: {
    /**
     * 只可输入数字自定义指令
     */
    numberOnly: {
      bind: (el) => {
        let state = 0; // 是否为中文输入法输入
        el.handler = function (inputVal) {
          if (state) {
            return;
          }
          let data = inputVal.data;
          let formatVal = /^[0-9]$/;
          if (!formatVal.test(data)) {
            if (!data) {
              return;
            }
            return el.children[0].value = el.children[0].value.replace(data, '');
          }
        };
        // 中文输入法键入开始
        el.onCompositionStart = () => {
          state = 1;
          el.children[0].value = el.children[0].value;
        };
        // 中文输入法键入结束
        el.onCompositionEnd = (e) => {
          state = 0;
          el.children[0].value = el.children[0].value.replace(e.data, '');
          return false;
        };
        el.addEventListener('input', el.handler);
        el.addEventListener('compositionstart', el.onCompositionStart);
        el.addEventListener('compositionend', el.onCompositionEnd);
      },
      unbind: (el) => {
        el.removeEventListener('input', el.handler);
        el.removeEventListener('compositionstart', el.onCompositionStart);
        el.removeEventListener('compositionend', el.onCompositionEnd);
      }
    },
    clickOutside: {
      // 初始化指令
      bind(el, binding) {
        function clickHandler(e) {
          // 这里判断点击的元素是否是本身，是本身，则返回
          if (el.contains(e.target)) {
            return false;
          }
          // 判断指令中是否绑定了函数
          if (binding.expression) {
            // 如果绑定了函数 则调用那个函数，此处binding.value就是handleClose方法
            binding.value(e);
          }
        }
        // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
        el.__vueClickOutside__ = clickHandler;
        document.addEventListener('click', clickHandler);
      },
      unbind(el) {
        // 解除事件监听
        document.removeEventListener('click', el.__vueClickOutside__);
        delete el.__vueClickOutside__;
      }
    }
  },
  data() {
    return {
      imei: this.value,
      devices: this.value,
      isArea: false,
      isFocus: false,
      isHover: false
    };
  },
  methods: {
    onChange() {
      let strs = this.devices.split(/\n/);
      let arr = [];
      strs.forEach((item) => {
        let str = item.replace(/\s*/g, '');
        if (str.length !== 0) {
          arr.push(str);
        }
      });
      this.$emit('input-change', arr);
    },
    /**
     * 添加
     */
    onSubmit() {
      let strs = this.devices.split(/\n/);
      let arr = [];
      strs.forEach((item) => {
        let str = item.replace(/\s*/g, '');
        if (str.length !== 0) {
          arr.push(str);
        }
      });
      this.onCancle();
      // this.device = arr.join(',');
      this.$emit('increase', arr);
    },
    /**
     * 取消
     */
    onCancle() {
      this.devices = '';
      this.close();
    },

    focus() {
      this.isArea = true;
      // this.imei = this.devices.replace(/\s+/g, '\n');
    },

    clear() {
      this.devices = '';
    },

    close() {
      this.imei = this.devices.replace(/[(\r\n)\r\n]+/g, ' ');
      this.isArea = false;
    }
  },
  computed: {
    countNum() {
      let imeis = this.devices.split(/\n/);
      let num = 0;
      imeis.forEach((item) => {
        let str = item.replace(/\s*/g, '');
        if (str.length !== 0) {
          num++;
        }
      });
      return num;
    }
  },
  watch: {
    devices(val) {
      this.$nextTick(() => {
        this.devices = val.replace(/[^\r\n0-9]/g, '');
        this.$emit('change', val);
      });
    },
    value: {
      handler(newVal) {
        this.devices = newVal;
      },
      deep: true
    }
  }
};
</script>

<style lang="scss">
.batch-input-device {
  z-index: 1;
  position: relative;
  height: 32px;
  margin-right: 10px;

  .ux-button {
    margin: 0;
  }

  .area-top {
    position: absolute;
    top: 0;
  }

  .area-bottom {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 16px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    border: 1px solid #bcc4d4;
    border-top: 0;
    background-color: #fff;

    .block-btn {
      display: flex;
    }
  }

  .area-bottom-focus {
    border-color: $color-primary;
  }

  .ux-input.el-textarea .el-textarea__inner {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    padding: 5px 16px;
    border-bottom-color: #eceef2;
    font-family: Arial;
  }
}

.batch-input-device:hover {
  .area-bottom {
    border-color: #8ab0ff;
  }

  .area-bottom-focus {
    border-color: $color-primary;
  }
}

.batch-input-device-hover {
  .ux-input.el-textarea .el-textarea__inner {
    border-color: #8ab0ff;
    border-bottom-color: #eceef2;
  }
}
</style>
